import { getDemoToken } from '../../../Auth/utils/demologin';
import { createSessionState, createTokenState } from '../../../Auth/components/AuthHelpers';
import { SessionState, TokenState } from '../../../Auth/utils/interfaces';
import { logger } from '../../../log';

export const _demologin = (setAuthState)  => {
  return (roles: string[], givenName: string, surname: string, email?: string): void => {
    logger.debug('login demologin', roles, givenName, surname, email);
    if (process.env.REACT_APP_DEMO_LOGIN_ENABLED === 'false') {
      return;
    }
    const userName: string = email ? email : `${givenName.toLowerCase()}.${surname.toLowerCase()}@mms3.test`;
    const signedToken: string = getDemoToken(roles, givenName, surname, userName);
    logger.find('/demologin').warn(userName, `[${roles.join(',')}]`);
    const token: TokenState = createTokenState(signedToken, null);
    const session: SessionState = createSessionState(signedToken);
    setAuthState({token, session});
  };
};

export default _demologin;
